module.exports = __webpack_public_path__ + "media/images/up-carrot-f44afd211c9891d94e65c5fa25c10b52.svg";